import * as R from 'ramda';

export default function ParentListItemController() {
  const vm = this;

  if (R.isNil(vm.canExpand)) {
    // If canExpand is not provided, then set default value;
    vm.canExpand = true;
  }
  if (R.isNil(vm.isExpanded)) {
    // If isExpanded is not provided, then set default value;
    vm.isExpanded = false;
  }
  vm.expandHandler = _expandHandler;


  /** *********************************************
   * Event Handlers
   */

  function _expandHandler($event) {
    $event.preventDefault();
    if (vm.canExpand) {
      if (!vm.isExpanded && vm.onExpand) {
        const promise = vm.onExpand();
        if (!promise) {
          vm.isExpanded = !vm.isExpanded;
          return;
        }
        promise.then(() => {
          vm.isExpanded = !vm.isExpanded;
        });
      } else {
        vm.isExpanded = !vm.isExpanded;
      }
    }
  }

  /** *********************************************
   * Private Functions
   */
}

ParentListItemController.$inject = [];
